export class EditGridReorderEvent {

    constructor(public fromIndex: number, public toIndex: number) {
    }
}
